// 自社情報画面
import React, { useState, useEffect, useCallback, useRef } from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  Grid,
  Divider,
  Button,
  Snackbar,
  Switch,
  Link,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import HelpIcon from '@material-ui/icons/Help';
import { useHistory, Redirect } from 'react-router-dom';
import 'date-fns';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  isLoggedIn,
  btnColor,
  invalidPhoneNumberRegex,
  invalidFaxNumberRegex,
  userRole,
  userMenuId
} from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import FooterComponent from '../components/FooterComponent';
import {
  getCompanyInformation,
  updateCompanyInformation,
  addCompanyStamp,
  getCompanyStamp,
  deleteCompanyStamp,
  addCompanyLogo,
  getCompanyLogo,
  deleteCompanyLogo,
  getStorageUsage
} from '../apicalls/companyInformation';
import { fetchAddressFromPostalCode } from '../apicalls/createCustomer';
import { NotFoundPage } from './NotFoundPage';
import { faqLink } from '../const/Const';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { RegisterBankAccountForm } from '../components/RegisterBankAccountForm';

export const CompanyInformation: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [userPermission] = useRecoilState(userRole);
  const [userMenu] = useRecoilState(userMenuId);
  const [buttonColor] = useRecoilState(btnColor);
  const [isPhoneNumber] = useRecoilState(invalidPhoneNumberRegex);
  const [isFaxNumber] = useRecoilState(invalidFaxNumberRegex);
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [mfaConfirmDialogOpen, setMfaConfirmDialogOpen] = useState(false);

  const [paymentFormsData, setPaymentFormsData] = useState([
    {
      bankIndex: '',
      bankName: '',
      branchName: '',
      selectedAccountType: 0,
      accountNumber: '',
      accountName: ''
    },
    {
      bankIndex: '',
      bankName: '',
      branchName: '',
      selectedAccountType: 0,
      accountNumber: '',
      accountName: ''
    },
    {
      bankIndex: '',
      bankName: '',
      branchName: '',
      selectedAccountType: 0,
      accountNumber: '',
      accountName: ''
    }
  ]);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [loading, setLoading] = useState(true);

  const [name, setName] = useState('');
  const [companyCode, setCompanyCode] = useState('');
  const [companyPostalCode1, setCompanyPostalCode1] = useState('');
  const [companyPostalCode2, setCompanyPostalCode2] = useState('');
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [faxNumber, setFaxNumber] = useState('');
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const [logoAvarable, setLogoAvailable] = useState(false);
  const [constructionLicense, setConstructionLicense] = useState('');
  const [email, setEmail] = useState('');
  const [stampImage, setStampImage] = useState<any>(null);
  const [logoImage, setLogoImage] = useState<any>(null);
  const [invoiceFreeField, setInvoiceFreeField] = useState<string>('');
  const [tenantId, setTenantId] = useState<any>('');
  const [stampFileFormat, setStampFileFormat] = useState<any>('');
  const [logoFileFormat, setLogoFileFormat] = useState<any>('');
  const [capacity, setCapacity] = useState<string>('');
  const [totalSize, setTotalSize] = useState<string>('');
  const [fileCount, setFileCount] = useState<string>('');
  const [pictureCount, setPictureCount] = useState<string>('');
  const [receiptCopyEnabled, setReceiptCopyEnabled] = useState(false);

  const bankInfo = paymentFormsData.map((formData, index) => {
    const bankIndex = index + 1;
    const bankName = formData.bankName ? formData.bankName.trim() : '';
    const branchName = formData.branchName ? formData.branchName.trim() : '';
    const selectedAccountType = formData.selectedAccountType
      ? formData.selectedAccountType
      : 0;
    const accountNumber = formData.accountNumber;
    const accountName = formData.accountName ? formData.accountName.trim() : '';

    return {
      bankIndex,
      bankName,
      branchName,
      selectedAccountType,
      accountNumber,
      accountName
    };
  });

  const companyInformation = {
    name: name.trim(),
    postalCode:
      String(companyPostalCode1.trim()) + String(companyPostalCode2.trim()),
    address: address.trim(),
    phoneNumber: phoneNumber.trim(),
    faxNumber: faxNumber.trim(),
    mfaEnabled,
    constructionLicense: constructionLicense.trim(),
    email: email.trim(),
    companyCode: companyCode.trim(),
    invoiceFreeField: invoiceFreeField,
    bankInfo,
    logoAvarable,
    receiptCopyEnabled
  };

  const inputReffStamp = useRef<any>(null);
  const inputReffLogo = useRef<any>(null);

  const getCompanyStampFun = useCallback(
    (id: any) => {
      getCompanyStamp(id).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setLoading(false);
              setStampFileFormat(data.data.file_format);
              setStampImage(data.data.data === '' ? null : data.data.data);
            }
          }
        }
      });
    },
    [changeLoggedInData]
  );

  const getCompanyLogoFun = useCallback(
    (id: any) => {
      getCompanyLogo(id).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setLoading(false);
              setLogoFileFormat(data.data.file_format);
              setLogoImage(data.data.data === '' ? null : data.data.data);
            }
          }
        }
      });
    },
    [changeLoggedInData]
  );

  const getCompanyDetails = useCallback(() => {
    getCompanyInformation().then((data: any) => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setLoading(false);
            setName(data.data.name);
            setCompanyCode(data.data.company_code);
            setCompanyPostalCode1(data.data.postal_code.slice(0, 3));
            setCompanyPostalCode2(data.data.postal_code.slice(-4));
            setAddress(data.data.address);
            setPhoneNumber(data.data.phone_number);
            setFaxNumber(data.data.fax_number);
            setMfaEnabled(data.data.mfa_enabled);
            setConstructionLicense(data.data.construction_license);
            setEmail(data.data.email);
            setTenantId(data.data.tenant_id);
            getCompanyStampFun(data.data.tenant_id);
            getCompanyLogoFun(data.data.tenant_id);
            setLogoAvailable(data.data.logo_available);
            setInvoiceFreeField(data.data.invoice_free_field);
            setReceiptCopyEnabled(data.data.receipt_copy_enabled);

            setPaymentFormsData(prevData =>
              prevData.map((formData, index) => ({
                ...formData, // 既存のプロパティをコピー
                bankIndex: data.data.bank_info_array[index]?.bank_index || '',
                bankName: data.data.bank_info_array[index]?.bank_name || '',
                branchName: data.data.bank_info_array[index]?.bank_branch || '',
                selectedAccountType:
                  data.data.bank_info_array[index]?.bank_account_type || 0,
                accountNumber:
                  data.data.bank_info_array[index]?.bank_account_number || '',
                accountName:
                  data.data.bank_info_array[index]?.bank_account_name || ''
              }))
            );
          }
        }
      }
    });
  }, [changeLoggedInData, getCompanyStampFun, getCompanyLogoFun]);

  const getFormData = (index: number, updatedValues: any) => {
    setPaymentFormsData(prevData => {
      const updatedFormsData = [...prevData];
      updatedFormsData[index] = {
        ...updatedFormsData[index],
        ...updatedValues
      };
      return updatedFormsData;
    });
  };

  useEffect(() => {
    getCompanyDetails();
  }, [getCompanyDetails]);

  useEffect(() => {
    if (userMenu != 'BM') {
      getStorageUsage().then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setCapacity(data.data.capacity);
              setTotalSize(data.data.total_size);
              setFileCount(data.data.file_count);
              setPictureCount(data.data.picture_count);
            }
          }
        }
      });
    }
  }, [userMenu]);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleMfaConfirmDialogOpen = () => {
    setMfaConfirmDialogOpen(true);
  };
  const handleMfaConfirmDialogClose = () => {
    setMfaConfirmDialogOpen(false);
  };

  const matches2 = useMediaQuery('(min-width:900px)');

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      invoiceFreeFieldInputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 140,
        alignItems: 'center',
        width: '100%'
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      invoiceFreeFieldMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 140,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      main: {
        minWidth: 700
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputPostalCode: {
        height: 40,
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      invoiceFreeFieldInput: {
        minHeight: 100,
        maxHeight: 150,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },

      sealImage: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 140,
        alignItems: 'center',
        width: '100%'
        // display: "flex",
        // flexDirection: "row",
        // height: "100px",
        // border: "1px solid gray"
      },
      sealtextContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 140,
        alignItems: 'center'
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      }
    })
  );

  // 関数内のupdateCompanyInformationはAPIを叩く関数。この関数内のthenの中でログインチェックを行なっている良くない設計
  // この関数の処理は、下のonSaveCompanyInformationの中以外でも二段階認証OFF時の確認ダイアログでも行なう必要があるため、関数名がほぼ同じでよくないが、仕方なく関数化している。
  const updateCompanyDetails = () => {
    updateCompanyInformation(companyInformation).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
          }
        }
      }
    });
  };

  const onSaveCompanyInformation = () => {
    if (name.trim() === '') {
      setErrorMessage('名前を入力してください。');
      setOpen(true);
    } else if (name.length > 30) {
      setErrorMessage('名前は30文字以内で入力してください。');
      setOpen(true);
    } else if (email.trim() === '') {
      setErrorMessage('メールアドレスを入力してください。');
      setOpen(true);
    } else if (address.length > 50) {
      setErrorMessage('住所は50文字以内で入力してください。');
      setOpen(true);
    } else if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email.trim()
      )
    ) {
      setErrorMessage('メールアドレスの形式が正しくありません。');
      setOpen(true);
    } else if (
      phoneNumber.trim() !== '' &&
      (isPhoneNumber.test(phoneNumber.trim()) || phoneNumber.trim().length > 15)
    ) {
      setErrorMessage('無効な電話番号です。');
      setOpen(true);
    } else if (
      faxNumber.trim() !== '' &&
      (isFaxNumber.test(faxNumber.trim()) || faxNumber.trim().length > 15)
    ) {
      setErrorMessage('無効なFAX番号です。');
      setOpen(true);
    } else if (
      companyPostalCode1 !== '' &&
      companyPostalCode2 !== '' &&
      (companyPostalCode1.length !== 3 || companyPostalCode2.length !== 4)
    ) {
      setErrorMessage('郵便番号の形式が間違っています。');
      setOpen(true);
    } else if (mfaEnabled === false) {
      handleMfaConfirmDialogOpen();
    } else {
      updateCompanyDetails();
    }
  };
  const handleStampImageDelete = () => {
    deleteCompanyStamp(tenantId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setStampFileFormat('');
            setStampImage(null);
            getCompanyStampFun(tenantId);
          }
        }
      }
    });
  };
  const handleStampImageUpload = () => {
    inputReffStamp.current.click();
  };
  const onStampImageChange = (e: any) => {
    //e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      const img: any = e.target.files[0];
      setStampFileFormat('');
      saveStampImage(img);
    }
  };
  const saveStampImage = async (file: File | undefined) => {
    onSaveStamp?.(file);
    setStampImage(null);
  };
  const handleLogoImageDelete = () => {
    deleteCompanyLogo(tenantId).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setErrorMessage(data.message);
            setOpenSuccess(true);
            setLogoFileFormat('');
            setLogoImage(null);
            getCompanyStampFun(tenantId);
          }
        }
      }
    });
  };
  const handleLogoImageUpload = () => {
    inputReffLogo.current.click();
  };
  const onLogoImageChange = (e: any) => {
    //e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      const img: any = e.target.files[0];
      setLogoFileFormat('');
      saveLogoImage(img);
    }
  };
  const saveLogoImage = async (file: File | undefined) => {
    onSaveLogo?.(file);
    setLogoImage(null);
  };
  const onSaveStamp = (file: any) => {
    //console.log("fil", file)
    const fileTypeAccepts = ['image/jpeg', 'image/png'];
    const data = new FormData();
    data.append('file_obj', file as any);
    if (file && fileTypeAccepts.includes(file.type)) {
      const reader = new FileReader();
      reader.onload = () => {
        setStampImage(reader.result);
      };
      reader.readAsDataURL(file);
      addCompanyStamp(tenantId, data).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
            }
          }
        }
      });
    } else {
      setErrorMessage('角印に利用できるファイル形式はJPEG、PNGに限ります。');
      setOpen(true);
      getCompanyStampFun(tenantId);
    }
  };
  const onSaveLogo = (file: any) => {
    //console.log("fil", file)
    const fileTypeAccepts = ['image/jpeg', 'image/png'];
    const data = new FormData();
    data.append('file_obj', file as any);
    if (file && fileTypeAccepts.includes(file.type)) {
      const reader = new FileReader();
      reader.onload = () => {
        setLogoImage(reader.result);
      };
      reader.readAsDataURL(file);
      addCompanyLogo(tenantId, data).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage(data.message);
              setOpenSuccess(true);
            }
          }
        }
      });
    } else {
      setErrorMessage('ロゴに利用できるファイル形式はJPEG、PNGに限ります。');
      setOpen(true);
      getCompanyLogoFun(tenantId);
    }
  };

  const byteFormat = (size: string) => {
    const numberSize = Number(size);
    const byte = 1000;
    const digits = 2;
    const mathRound = (number: number) => {
      return (Math.round(number * 10 ** digits) / 10 ** digits).toFixed(digits);
    };
    if (numberSize >= byte ** 4) {
      const terabyte = numberSize / byte ** 4;
      return mathRound(terabyte) + 'TB';
    } else if (numberSize >= byte ** 3) {
      const gigabyte = numberSize / byte ** 3;
      return mathRound(gigabyte) + 'GB';
    } else if (numberSize >= byte ** 2) {
      const megabyte = numberSize / byte ** 2;
      return mathRound(megabyte) + 'MB';
    } else if (numberSize >= byte) {
      const kilobyte = numberSize / byte ** 2;
      return mathRound(kilobyte) + 'KB';
    } else {
      return numberSize + 'B';
    }
  };

  const handleAddressFetch = async () => {
    try {
      const result = await fetchAddressFromPostalCode(
        `${companyPostalCode1}${companyPostalCode2}`
      );

      if (result.success) {
        const { prefecture = '', city = '', suburb = '' } = result.data;
        const fullAddress = `${prefecture}${city}${suburb}`.trim();
        setAddress(fullAddress);

        setErrorMessage('');
      } else {
        setErrorMessage(result.message || '住所の取得に失敗しました');
        setOpen(true);
      }
    } catch (error) {
      setErrorMessage(
        'システムエラーが発生しました。住所は手動で入力してください。'
      );
      setOpen(true);
    }
  };

  const classes = useStyles();
  const history: any = useHistory();

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userPermission === 2 || userPermission === 3) {
    return <NotFoundPage />;
  }

  return (
    <div>
      <AppBarComponent patternName='company_information' />
      {loading === true || userPermission === undefined ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight - 150
          }}
        >
          {/* エラーメッセージ */}
          <div style={{ margin: 15 }}>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='error'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openSuccess}
              autoHideDuration={4000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {errorMessage}
              </Alert>
            </Snackbar>

            {/* 二段階認証OFFでよいか確認するダイアログ */}
            <Dialog
              open={mfaConfirmDialogOpen}
              // onClose={handleMfaConfirmDialogClose}
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
            >
              <DialogTitle id='alert-dialog-title'>
                {'二段階認証がOFFになっています。'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  セキュリティの観点から、二段階認証をONにすることを強く推奨します
                  <br />
                  <Link
                    href={faqLink.mfa}
                    target='_blank'
                    rel='noopener noreferrer'
                    color='inherit'
                    style={{ textDecoration: 'underline' }}
                  >
                    ヘルプページ
                  </Link>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    updateCompanyDetails();
                    handleMfaConfirmDialogClose();
                  }}
                  color='default'
                >
                  OFFのままにする
                </Button>
                <Button
                  onClick={() => {
                    setMfaEnabled(true);
                    // setMfaEnabled(true)を実行しても、なぜかcompanyInformation["mfaEnabled"]の値がtrueにならないので、直接変更する
                    companyInformation['mfaEnabled'] = true;
                    updateCompanyDetails();
                    handleMfaConfirmDialogClose();
                  }}
                  color='primary'
                  autoFocus
                >
                  ONにする
                </Button>
              </DialogActions>
            </Dialog>

            <div className='table-top-container-customer'>
              <div>
                <Button
                  style={{ marginRight: 15, backgroundColor: buttonColor }}
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    onSaveCompanyInformation();
                  }}
                >
                  保存
                </Button>
              </div>
            </div>

            <div>
              <div
                className='table-top-container-customer'
                style={{ backgroundColor: '#FFFFFF' }}
              >
                <div
                  style={{
                    fontWeight: 'bold',
                    padding: 15,
                    paddingBottom: 0,
                    fontSize: 24
                  }}
                >
                  {'自社情報'}
                </div>
              </div>

              <Grid
                container
                style={{
                  backgroundColor: '#FFFFFF',
                  paddingBottom: 15,
                  marginBottom: 15
                }}
              >
                <Grid item xs={matches2 ? 4 : 12}>
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        名前<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={name}
                          maxLength={30}
                          onChange={e => {
                            setName(e.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        登録番号
                        <CustomTooltip
                          title={tooltipContents.companyNum}
                          placement='right'
                        >
                          <HelpIcon
                            style={{
                              color: 'white',
                              marginLeft: 8,
                              marginBottom: 4
                            }}
                          />
                        </CustomTooltip>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={companyCode}
                          maxLength={30}
                          onChange={e => {
                            setCompanyCode(e.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        Eメール<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={email}
                          maxLength={50}
                          onChange={e => {
                            setEmail(e.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div
                      className={classes.textMainContainer}
                      style={{ height: '100px' }}
                    >
                      <div className={classes.textContainer}>郵便番号</div>
                    </div>
                    <div
                      className={classes.inputMainContainer}
                      style={{ height: '100px' }}
                    >
                      <div className={classes.inputContainer}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <input
                            value={companyPostalCode1}
                            maxLength={3}
                            type='text'
                            onChange={text => {
                              setCompanyPostalCode1(text.target.value);
                            }}
                            className={classes.inputPostalCode}
                            style={{ width: 60 }}
                          />
                          <span style={{ margin: 5 }}> - </span>
                          <input
                            value={companyPostalCode2}
                            type='text'
                            maxLength={4}
                            onChange={text => {
                              setCompanyPostalCode2(text.target.value);
                            }}
                            className={classes.inputPostalCode}
                            style={{ width: 80 }}
                          />
                        </div>
                        <div style={{ padding: '5px 0' }}>
                          <Button
                            style={{
                              backgroundColor: buttonColor,
                              padding: '5px 10px',
                              width: 'auto',
                              minWidth: '80px'
                            }}
                            variant='contained'
                            color='secondary'
                            onClick={handleAddressFetch}
                          >
                            住所反映
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>住所</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={address}
                          maxLength={50}
                          onChange={e => {
                            setAddress(e.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>TEL</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={phoneNumber}
                          maxLength={15}
                          onChange={e => {
                            setPhoneNumber(e.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>FAX</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={faxNumber}
                          maxLength={15}
                          onChange={e => {
                            setFaxNumber(e.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>二段階認証</div>
                      <CustomTooltip
                        title={tooltipContents.mfa}
                        placement='top'
                        interactive
                      >
                        <HelpIcon style={{ color: 'white', marginLeft: 8 }} />
                      </CustomTooltip>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <Grid
                          component='label'
                          container
                          alignItems='center'
                          spacing={1}
                        >
                          <Grid item>OFF</Grid>
                          <Grid item>
                            <Switch
                              checked={mfaEnabled}
                              onChange={e => {
                                setMfaEnabled(e.target.checked);
                              }}
                              color='primary'
                              name='mfaEnable'
                              inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                          </Grid>
                          <Grid item>ON</Grid>
                        </Grid>
                      </div>
                    </div>
                  </div>
                  {/* 業務管理を使用しないテナントには会社印を表示しない */}
                  {userMenu !== 'Storage' && userMenu !== 'SiteManage' && (
                    <>
                      <Divider
                        style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                      />
                      <div className={classes.subContainer}>
                        <div className={classes.sealtextContainer}>
                          <div className={classes.textContainer}>会社印</div>
                        </div>
                        <div className={classes.sealImage}>
                          <div className={classes.inputContainer}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              {stampImage !== null ? (
                                <div className='seal-image-container'>
                                  {stampFileFormat !== '' ? (
                                    <img
                                      style={{
                                        objectFit: 'cover',
                                        height: '50px',
                                        width: '50px'
                                      }}
                                      src={`data:${stampFileFormat};base64,${stampImage}`}
                                      alt='company-seal'
                                    />
                                  ) : (
                                    <img
                                      style={{
                                        objectFit: 'cover',
                                        height: '50px',
                                        width: '50px'
                                      }}
                                      src={stampImage}
                                      alt='company-seal'
                                    />
                                  )}
                                  <input
                                    type='file'
                                    style={{ display: 'none' }}
                                    id='image_name_stamp'
                                    ref={inputReffStamp}
                                    onChange={onStampImageChange}
                                  />
                                  <div className='image-seal-button displayFlexRow'>
                                    <button onClick={handleStampImageUpload}>
                                      画像を選択
                                    </button>
                                  </div>
                                  <div className='image-seal-button displayFlexRow'>
                                    <button onClick={handleStampImageDelete}>
                                      削除する
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <div className='seal-image-container'>
                                  <div
                                    style={{
                                      padding: '5px',
                                      objectFit: 'cover',
                                      height: '50px',
                                      width: '50px',
                                      backgroundColor: 'gray'
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: 50,
                                        width: 50,
                                        color: '#FFFFFF'
                                      }}
                                    >
                                      No Image
                                    </div>
                                  </div>

                                  <input
                                    type='file'
                                    style={{ display: 'none' }}
                                    id='image_name_stamp'
                                    ref={inputReffStamp}
                                    onChange={onStampImageChange}
                                  />
                                  <div className='image-seal-button displayFlexRow'>
                                    <button onClick={handleStampImageUpload}>
                                      画像を選択
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        建設業許可番号
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={constructionLicense}
                          maxLength={70}
                          onChange={e => {
                            setConstructionLicense(e.target.value);
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>

                  {logoAvarable && (
                    <>
                      <Divider
                        style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                      />
                      <div className={classes.subContainer}>
                        <div className={classes.sealtextContainer}>
                          <div className={classes.textContainer}>会社ロゴ</div>
                        </div>
                        <div className={classes.sealImage}>
                          <div className={classes.inputContainer}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              {logoImage !== null ? (
                                <div className='seal-image-container'>
                                  {logoFileFormat !== '' ? (
                                    <img
                                      style={{
                                        objectFit: 'cover',
                                        height: '50px',
                                        width: '50px'
                                      }}
                                      src={`data:${logoFileFormat};base64,${logoImage}`}
                                      alt='company-seal'
                                    />
                                  ) : (
                                    <img
                                      style={{
                                        objectFit: 'cover',
                                        height: '50px',
                                        width: '50px'
                                      }}
                                      src={logoImage}
                                      alt='company-seal'
                                    />
                                  )}
                                  <input
                                    type='file'
                                    style={{ display: 'none' }}
                                    id='image_name_logo'
                                    ref={inputReffLogo}
                                    onChange={onLogoImageChange}
                                  />
                                  <div className='image-seal-button displayFlexRow'>
                                    <button onClick={handleLogoImageUpload}>
                                      画像を選択
                                    </button>
                                  </div>
                                  <div className='image-seal-button displayFlexRow'>
                                    <button onClick={handleLogoImageDelete}>
                                      削除する
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <div className='seal-image-container'>
                                  <div
                                    style={{
                                      padding: '5px',
                                      objectFit: 'cover',
                                      height: '50px',
                                      width: '50px',
                                      backgroundColor: 'gray'
                                    }}
                                  >
                                    <div
                                      style={{
                                        height: 50,
                                        width: 50,
                                        color: '#FFFFFF'
                                      }}
                                    >
                                      No Image
                                    </div>
                                  </div>

                                  <input
                                    type='file'
                                    style={{ display: 'none' }}
                                    id='image_name_logo'
                                    ref={inputReffLogo}
                                    onChange={onLogoImageChange}
                                  />
                                  <div className='image-seal-button displayFlexRow'>
                                    <button onClick={handleLogoImageUpload}>
                                      画像を選択
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {/* 業務管理を使用しないテナントには請求書備考欄を表示しない */}
                  {userMenu !== 'Storage' && userMenu !== 'SiteManage' && (
                    <>
                      <Divider
                        style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                      />
                      <div className={classes.subContainer}>
                        <div className={classes.invoiceFreeFieldMainContainer}>
                          <div className={classes.textContainer}>
                            請求書備考欄
                          </div>
                          <CustomTooltip
                            title={tooltipContents.companyFreeField}
                            placement='top'
                            interactive
                          >
                            <HelpIcon
                              style={{ color: 'white', marginLeft: 8 }}
                            />
                          </CustomTooltip>
                        </div>
                        <div
                          className={classes.invoiceFreeFieldInputMainContainer}
                        >
                          <div className={classes.inputContainer}>
                            <textarea
                              value={invoiceFreeField}
                              maxLength={50}
                              placeholder='50文字以内'
                              onChange={e => {
                                setInvoiceFreeField(e.target.value);
                              }}
                              className={classes.invoiceFreeFieldInput}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        領収書控え表示
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <Grid
                          component='label'
                          container
                          alignItems='center'
                          spacing={1}
                        >
                          <Grid item>非表示</Grid>
                          <Grid item>
                            <Switch
                              checked={receiptCopyEnabled}
                              onChange={e => {
                                setReceiptCopyEnabled(e.target.checked);
                              }}
                              color='primary'
                              name='receiptCopyEnable'
                              inputProps={{
                                'aria-label': 'receipt copy checkbox'
                              }}
                            />
                          </Grid>
                          <Grid item>表示</Grid>
                        </Grid>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
              {/* 業務管理を使用しないテナントには支払い先情報を表示しない */}
              {userMenu !== 'Storage' && userMenu !== 'SiteManage' && (
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    marginBottom: 15,
                    paddingBottom: 15
                  }}
                >
                  {paymentFormsData.map((formData, index) => (
                    <Grid item xs={matches2 ? 4 : 12} key={index}>
                      <RegisterBankAccountForm
                        formData={formData}
                        index={index}
                        getFormData={getFormData}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}

              {userMenu != 'BM' && (
                <Grid
                  container
                  style={{
                    backgroundColor: '#FFFFFF',
                    marginBottom: 15,
                    paddingBottom: 15
                  }}
                >
                  <Grid item xs={matches2 ? 4 : 12}>
                    <div
                      className='table-top-container-customer'
                      style={{ backgroundColor: '#FFFFFF' }}
                    >
                      <div
                        style={{
                          fontWeight: 'bold',
                          padding: 15,
                          paddingBottom: 0,
                          fontSize: 24
                        }}
                      >
                        ストレージ利用状況
                      </div>
                    </div>
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>最大容量</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainer}
                          style={{ textAlign: 'right' }}
                        >
                          {capacity ? byteFormat(capacity) : '--'}
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />

                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>保存容量</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainer}
                          style={{ textAlign: 'right' }}
                        >
                          {totalSize ? byteFormat(totalSize) : '--'}
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>資料登録数</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainer}
                          style={{ textAlign: 'right' }}
                        >
                          {fileCount
                            ? Number(fileCount).toLocaleString() + '枚'
                            : '--'}
                        </div>
                      </div>
                    </div>

                    <Divider
                      style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                    />
                    <div className={classes.subContainer}>
                      <div className={classes.textMainContainer}>
                        <div className={classes.textContainer}>写真登録数</div>
                      </div>
                      <div className={classes.inputMainContainer}>
                        <div
                          className={classes.inputContainer}
                          style={{ textAlign: 'right' }}
                        >
                          {pictureCount
                            ? Number(pictureCount).toLocaleString() + '枚'
                            : '--'}
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              )}
            </div>
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
